<template>
    <v-dialog v-model="showDialog" max-width="600px">
        <v-card :title="t('title.terminalSystemDialog')" class="ma-2">
            <v-card-text>
                <v-form ref="form">
                    <v-text-field class="mt-5 mx-3" outlined :label="t('model.description')" v-model="system.description" readonly></v-text-field>
                    <v-select class="mt-5 mx-3" outlined :label="t('model.section')" v-model="system.sectionId" :items="sections" item-value="id" item-title="label" readonly> </v-select>
                    <v-checkbox class="mx-3" :label="t('model.isActive')" v-model="system.isActive"></v-checkbox>
                    <v-text-field class="mx-3" outlined :label="t('model.order')" v-model="system.sort" :rules="[rules.required]"></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" dark class="mb-2" variant="outlined" @click="saveBadge()" :text="t('button.save')">
                </v-btn>
                <v-btn color="secondary" dark class="mb-2 mr-4" variant="outlined" @click="canceled()" :text="t('button.cancel')">
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { useI18n } from "vue-i18n";
import { ref } from "vue";

const { t } = useI18n();
const emit = defineEmits(['onAccept', 'onCancel']);
const props = defineProps({
    sections: {
        type: Array,
        required: true,
    }
});

const form = ref();
const showDialog = defineModel("showDialog", { type: Boolean, default: false });
const system = defineModel("system", { type: Object, required: true });

const rules = {
    required: value => !!value || t('message.required'),
}

const saveBadge = async () => {
    const { valid } = await form.value.validate();
    if (!valid)
        return;
    emit('onAccept');
    showDialog.value = false;
}

const canceled = () => {
    emit('onCancel');
    showDialog.value = false;
}

</script>